module.exports = __webpack_public_path__ + "static/assets/973d7d8a7e7ea5de7ded6c0c6aec9e9a.png";